import React, { memo } from "react";
import { Modal, ModalBody } from "reactstrap";
import { IoClose } from "react-icons/io5";
import "./ImagePreviewModal.css";

const ImagePreviewModal = ({
  isOpen,
  toggle,
  imageSrc,
  alt = "Full Preview",
  zIndex = 10000,
  className = "",
}) => {
  if (!imageSrc) return null;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      zIndex={zIndex}
      className={`image-preview-modal-dialog ${className}`.trim()}
      contentClassName="bg-transparent border-0"
    >
      <ModalBody className="p-0 d-flex justify-content-center align-items-center">
        <div className="image-preview-modal-wrapper">
          <button
            type="button"
            className="image-preview-modal-close-btn"
            onClick={toggle}
            aria-label="Close image preview"
          >
            <IoClose size={22} />
          </button>
          <img
            src={imageSrc}
            alt={alt}
            className="img-fluid image-preview-modal-img"
            loading="lazy"
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default memo(ImagePreviewModal);
